"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETTSTypes = void 0;
var ETTSTypes;
(function (ETTSTypes) {
    ETTSTypes["aws:maxim"] = "aws:maxim";
    ETTSTypes["aws:tatyana"] = "aws:tatyana";
    ETTSTypes["yandex:alena"] = "yandex:alena";
    ETTSTypes["yandex:filipp"] = "yandex:filipp";
    ETTSTypes["yandex:oksana"] = "yandex:oksana";
    ETTSTypes["yandex:jane"] = "yandex:jane";
    ETTSTypes["yandex:omazh"] = "yandex:omazh";
    ETTSTypes["yandex:zahar"] = "yandex:zahar";
    ETTSTypes["yandex:ermil"] = "yandex:ermil";
    ETTSTypes["yandex:silaerkan"] = "yandex:silaerkan";
    ETTSTypes["yandex:erkanyavas"] = "yandex:erkanyavas";
    ETTSTypes["yandex:alyss"] = "yandex:alyss";
    ETTSTypes["yandex:nick"] = "yandex:nick"; // en-US
})(ETTSTypes || (exports.ETTSTypes = ETTSTypes = {}));
//# sourceMappingURL=tts.enum.js.map